import React, { useState } from "react";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";

export const table2Data = [];
export const table2ColDefs = [];

export const CreditNoteEntryTable = (props) => {
    return (
        <ModalBasic
            id="salaryBankTransfer"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <div className="input-fields p-[30px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Creadit note details</span>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-[12px] mb-3">
                        <div className="input-grp">
                            <label>Credit note no</label>
                            <TextInput type="number" id="creditNoteNo" name="creditNoteNo" value={props.creditNoteDetails.creditNoteNo} handleChange={(event) => props.handleChange(event, "creditNoteNo")} disabled />
                        </div>
                        <div className="input-grp">
                            <label>Date</label>
                            <TextInput type="date" id="date" name="date" value={props.creditNoteDetails.date} handleChange={(event) => props.handleChange(event, "date")} className={props.validState?.error?.date !== undefined ? "error" : ""} />
                        </div>
                        <div className="input-grp col-span-2">
                            <label>Party account</label>
                            <SingleSelectWithSearch
                                drpIdentity={"partyList"}
                                optionArray={props.creditNoteDetails.partyList}
                                value={props.creditNoteDetails.idPartyAccount}
                                searchText={props.creditNoteDetails.partyACName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idPartyAccount !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch id="partyAccount" name="partyAccount" value={props.creditNoteDetails.partyAccount} handleChangeTest={(event) => props.handleSelectChange(event, "partyAccount")} className={props.validState?.error?.partyAccount !== undefined ? "error" : ""}/> */}
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Particulars</label>
                            <SingleSelectWithSearch
                                drpIdentity={"particulars"}
                                optionArray={props.creditNoteDetails.particularsList}
                                value={props.creditNoteDetails.particularsId}
                                searchText={props.creditNoteDetails.particularsName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                // classParams={props.validState?.error?.particularsId !== undefined ? "error" : ""}
                            />
                            {/* <TextInput type="text" id="particulars" name="particulars" value={props.creditNoteDetails.particulars} handleChange={(event) => props.handleChange(event, "particulars")} className={props.validState?.error?.particulars !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Reference No</label>
                            <TextInput type="text" id="refNo" name="refNo" value={props.creditNoteDetails.refNo} handleChange={(event) => props.handleChange(event, "refNo")} className={props.validState?.error?.refNo !== undefined ? "error" : ""} />
                        </div>
                        <div className="input-grp">
                            <label>Amount</label>
                            <TextInput type="number" id="amount" name="amount" value={props.creditNoteDetails.amount} handleChange={(event) => props.handleChange(event, "amount")} className={props.validState?.error?.amount !== undefined ? "error" : ""} />
                        </div>
                        <div className="input-grp">
                            <label>Cbit note type</label>
                            <SingleSelectWithSearch
                                drpIdentity={"NoteType"}
                                optionArray={props.creditNoteDetails.taxtTypeList}
                                value={props.creditNoteDetails.idTaxtType}
                                searchText={props.creditNoteDetails.taxtTypeName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idTaxtType !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch id="cbitNoteType" name="cbitNoteType" value={props.creditNoteDetails.cbitNoteType} handleChangeTest={(event) => props.handleSelectChange(event, "cbitNoteType")} className={props.validState?.error?.cbitNoteType !== undefined ? "error" : ""} /> */}
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Tax</label>
                            <SingleSelectWithSearch
                                drpIdentity={"TaxtStructureList"}
                                optionArray={props.creditNoteDetails.taxtStructureList}
                                value={props.creditNoteDetails.idTaxStructure}
                                searchText={props.creditNoteDetails.taxStructureName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idTaxStructure !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch id="tax" name="tax" value={props.creditNoteDetails.tax} handleChangeTest={(event) => props.handleSelectChange(event, "tax")} className={props.validState?.error?.tax !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>SGST {props.creditNoteDetails.taxtTypeName === 'INTRASTATE' && props.creditNoteDetails.sgst > 0 ? `- ${props.creditNoteDetails.sgst}` : ""}</label>
                            <TextInput type="number" id="sgst" name="sgstAmt" value={props.creditNoteDetails.sgstAmt} handleChange={(event) => props.handleChange(event, "sgst")} className={props.validState?.error?.sgst !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>CGST  {props.creditNoteDetails.taxtTypeName === 'INTRASTATE' && props.creditNoteDetails.cgst > 0 ? `- ${props.creditNoteDetails.cgst}` : ""}</label>
                            <TextInput type="number" id="cgst" name="cgstAmt" value={props.creditNoteDetails.cgstAmt} handleChange={(event) => props.handleChange(event, "cgst")} className={props.validState?.error?.cgst !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>IGST {props.creditNoteDetails.igst > 0 ? props.creditNoteDetails.taxtTypeName === 'INTRASTATE' ? "" : `-${props.creditNoteDetails.igst}` : ""}</label>
                            <TextInput type="number" id="igst" name="igstAmt" value={props.creditNoteDetails.igstAmt} handleChange={(event) => props.handleChange(event, "igst")} className={props.validState?.error?.igst !== undefined ? "error" : ""} disabled />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3">

                        <div className="input-grp">
                            <label>TCS percentage</label>
                            <TextInput
                                type="number"
                                id="tcsPercentage"
                                name="tcsPercentage"
                                value={props.creditNoteDetails.tcsPercentage}
                                handleChange={(event) => props.handleChange(event, "tcsPercentage")}
                            // className={props.validState?.error?.tcsPercentage !== undefined ? "error" : ""} 
                            />
                        </div>
                        <div className="input-grp">
                            <label>TCS Amount</label>
                            <TextInput type="number" id="tcsAmt" name="tcsAmt" value={props.creditNoteDetails.tcsAmt}
                                //handleChange={(event) => props.handleChange(event, "tcsAmt")} 
                                className={props.validState?.error?.tcsAmt !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>Final Amount</label>
                            <TextInput type="number" id="finalAmt" name="finalAmt" value={props.creditNoteDetails.finalAmt} handleChange={(event) => props.handleChange(event, "finalAmt")} disabled />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3.5">
                        <div className="input-grp col-span-2">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks" value={props.creditNoteDetails.remarks} handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>
                    <div className="btn-grp inline-flex gap-2.5">
                        <button className="update-btn btns" onClick={() => props.submitCreditNote()} disabled={props.isSaving}>
                            {props.creditNoteDetails.updateStatus === 1 ? "Update" : "Save"}
                        </button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    )
}